import React from 'react'
import _ from 'lodash'
import { TouchableOpacity, View, Platform, RefreshControl, Linking } from 'react-native'
import dayjs from 'dayjs'
import * as acl from 'x/utils/acl'

import xCONS from 'x/config/constants'
import moment from 'moment'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

// import MCIcon from '@expo/vector-icons/MaterialCommunityIcons'
import XCustomHeader from 'xui/components/XCustomHeader'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCard from 'xui/components/XCard'
import XText from 'xui/components/XText'
import XSpinner from 'xui/components/XSpinner'
// import SRowItem from '../../components/renderRowLeftAndRight'
import { COLORS, STYLES } from 'x/config/styles'
import BaseSubscriptionView from 'x/modules/subscription/BaseSubscriptionView'
import p from 'x/config/platform-specific'
import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import XButton from 'xui/components/XButton'
import assets from 'xui/assets'
import * as util from 'x/utils/util'
import ProfilePackage from 'xui/components/ProfilePackage'
import XImage from 'xui/components/XImage'
import XDocumentDropzone from 'xui/components/XDocumentDropzone'
import * as upload from 'x/utils/upload'
import { IXSellyFile } from 'x/index'
import { MODE } from 'x/config/mode'
import XIconButton from 'xui/components/XIconButton'
import XIcon from 'xui/components/XIcon'
import { isImmutable } from 'immutable'
import XOverlayLoading from 'xui/components/XOverlayLoading'

import XStatusBar from '../../components/XStatusBar'

import XUISubcriptionDetail from './XUISubcriptionDetail'
import XPendingSubcriptionPayment from './XPendingSubcriptionPayment'

// const BTN_BUY_PACKAGE = require('../../img/btn/btn_buy_package.png')
const BTN_BUY_PACKAGE = assets.images.btn.buyPackage

export const RenderBtnCallActionPackage = (text: string, onPressBtn: () => void) => {
  return (
    <TouchableOpacity style={{ width: 125, height: 50 }} onPress={() => onPressBtn()}>
      <HStack w='125px' h='50px'>
        <XImage
          // width={width}
          // height={height}
          source={BTN_BUY_PACKAGE}
          w='125px'
          h='50px'
          // style={StyleSheet.flatten(style)}
          // style={{
          //   width: '100%',
          // }}
        />
        <HStack alignItems='center' justifyContent='center' position='absolute' top='0' right='0' bottom='0' left='0'>
          <XText color={COLORS.WHITE} bold fontSize='lg'>
            {text}
          </XText>
        </HStack>
      </HStack>
    </TouchableOpacity>
  )
}

const { expireWarningInDay, expireDangerInDay, orderDangerInPercentage, orderWarningInPercentage } = xCONS.SUBSCRIPTION_SETTINGS

const SERVER_DATE_FORMAT = 'YYYY-MM-DD'

const { FONT_SIZE_SMALLER } = STYLES
const { APP_MAIN, APP_SECONDARY, TEXT_ACTIVE, TEXT_INACTIVE, TEXT_ACTIVE_DARK, BRAND_Warning, BRAND_Danger, BG_LIGHT_GREY } = COLORS

const SRowItem = ({ label = '', desc = '', labelStyle = {}, descStyle = {} }) => (
  <View
    style={{
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 8,
    }}
  >
    <XText variant='inactive' style={labelStyle}>
      {label}
    </XText>
    <XText style={descStyle}>{desc}</XText>
  </View>
)

export const renderCurrentBillingCycle = (subscription) => {
  const orderCount = subscription.get('order_count_curr') || 0
  const orderQuota = subscription.get('order_count_quota') || 0
  const startBillingDate = subscription.has('start_billing_date')
    ? subscription.get('start_billing_date')
    : subscription.get('startBillingDate')
  const endBillingDate = subscription.has('end_billing_date') ? subscription.get('end_billing_date') : subscription.get('endBillingDate')
  const txtEndBillingDate = dayjs(endBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
  const txtStartBillingDate = dayjs(startBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)

  const orderCountColor = orderCount >= orderQuota ? COLORS.RED : COLORS.TEXT_ACTIVE
  return (
    <VStack w='full'>
      <HStack h='10' alignItems='center' justifyContent='center'>
        <XText bold fontSize='lg'>
          รอบบิลปัจจุบัน
        </XText>
      </HStack>
      <VStack px='2' h='12'>
        <HStack alignItems='center' justifyContent='center'>
          <HStack flex={1}>
            <XText fontSize='md' variant='inactive'>
              จำนวนออเดอร์ที่ใช้ไป
            </XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText bold fontSize='md' color={orderCountColor}>{`${orderCount}`}</XText>
            <XText bold fontSize='md'>{` / ${orderQuota}`}</XText>
          </HStack>
        </HStack>
        <HStack>
          <HStack flex={1}>
            <XText fontSize='md' variant='inactive'>
              ช่วงเวลา
            </XText>
          </HStack>
          <HStack flex={3} justifyContent='flex-end'>
            <XText fontSize='md' variant='inactive'>{`${txtStartBillingDate} - ${txtEndBillingDate}`}</XText>
          </HStack>
        </HStack>
      </VStack>
    </VStack>
  )
}

const LOCAL_DATE_FORMAT = 'D MMM YYYY'

export default abstract class BaseUISubscriptionView extends BaseSubscriptionView {
  _renderPackage = () => {
    // if (!util.isDevMode()) {
    //   return null
    // }
    return (
      <XCard p='2' w='full'>
        <XButton w='full' onPress={() => this._navToInAppPurchaseView('upgrade')}>
          เปิดแพ็กใหม่
        </XButton>
      </XCard>
    )
  }

  _renderProfile = () => {
    const { subscription, profile } = this.props
    if (_.isNil(profile) || _.isNil(subscription)) {
      return null
    }
    // console.log('profile => ', profile.toJS())
    if (!profile || !profile.get('user_id')) {
      return null
    }

    const typeId: number = subscription.has('type') ? subscription.get('type') : 0

    return <ProfilePackage profile={profile.toJS()} typeId={typeId} />
  }

  // _renderNavToUpgradePakage = () => {
  //   const { subscription } = this.props
  //   if (_.isNil(subscription)) {
  //     return null
  //   }
  //   let isCanRenderBuyPack = false
  //   if (util.isDevMode() || p.op.isIOS()) {
  //     isCanRenderBuyPack = true
  //   }

  //   const AVAILABLE_TYPES = [1, 999]
  //   if (p.op.isIOS() && !_.includes(AVAILABLE_TYPES, subscription.get('type'))) {
  //     return null
  //   }
  //   if (!isCanRenderBuyPack) {
  //     return null
  //   }
  //   return (
  //     <VStack w={'full'} bgColor={COLORS.APP_SECONDARY} space={'1'} alignItems={'center'} justifyContent={'center'} py='2'>
  //       <HStack>
  //         <XText fontSize={'md'} bold>
  //           เพิ่มประสิทธิภาพให้การทำงานไม่สะดุด อย่างต่อเนื่อง
  //         </XText>
  //       </HStack>
  //       <XButton onPress={() => this._navToInAppPurchaseView()}>
  //         <XText color={COLORS.WHITE} fontSize={'md'}>
  //           อัพเกรดแพ็กเกจ
  //         </XText>
  //       </XButton>
  //     </VStack>
  //   )
  // }

  // TO NOT UES NOW
  // _renderBuyNewPackageButton = () => {
  //   const { subscription } = this.props
  //   if (_.isNil(subscription)) {
  //     return null
  //   }
  //   // let isCanRenderBuyPack = false
  //   // if (util.isDevMode() || p.op.isIOS()) {
  //   //   isCanRenderBuyPack = true
  //   // }

  //   const AVAILABLE_TYPES = [1]
  //   if (!_.includes(AVAILABLE_TYPES, subscription.get('type'))) {
  //     return null
  //   }
  //   const isCanRenderBuyPack = this._canRenderBuyPackage()
  //   if (!isCanRenderBuyPack) {
  //     return null
  //   }

  //   let textLabel = 'อัพเกรดแพ็กเกจ'
  //   const subscriptionType = subscription.get('type')
  //   if (subscriptionType === 1) {
  //     textLabel = 'ซื้อแพ็กเกจ'
  //   }

  //   // แพ็กเกจทดลองใช้ จะไม่แสดงปุ่มซื้อแพ็กเกจบน prod
  //   // TODO: ต้องกลับมาแก้ไขหากว่าการซื้อแพ็กเกจบนเว็บพร้อมใช้งาน
  //   if (subscriptionType === 999) {
  //     return null
  //   }

  //   return (
  //     <HStack flex={1} justifyContent='flex-end' alignItems='center'>
  //       <TouchableOpacity
  //         onPress={() => this._navToInAppPurchaseView('buy_package')}
  //         style={{
  //           backgroundColor: COLORS.APP_MAIN,
  //           borderColor: COLORS.APP_MAIN,
  //           borderWidth: 1,
  //           marginTop: 4,
  //           borderRadius: 90,
  //           alignItems: 'center',
  //           justifyContent: 'center',
  //           width: 180,
  //         }}
  //       >
  //         <XText my='1' bold fontSize='lg' color={COLORS.WHITE}>
  //           {textLabel}
  //         </XText>
  //       </TouchableOpacity>
  //     </HStack>
  //   )
  // }

  // _renderExtendPackageButton = () => {
  //   const { subscription } = this.props
  //   const AVAILABLE_TYPES = [2, 3, 4, 5]
  //   if (_.isNil(subscription) || !_.includes(AVAILABLE_TYPES, subscription.get('type'))) {
  //     return null
  //   }
  //   // console.log('subscription => ', subscription.toJS())
  //   let isCanRenderBuyPack = false
  //   if (util.isDevMode() || p.op.isIOS()) {
  //     isCanRenderBuyPack = true
  //   }

  //   const end = dayjs(subscription.get('m_e_date')) // อายุการใช้งานงานวันสุดท้ายของแพ็เกจ
  //   const toDay = dayjs(new Date())
  //   // console.log('end => ', end.format('DD/MM/YYYY'))
  //   // console.log('toDay => ', toDay.format('DD/MM/YYYY'))
  //   const timeLeft = end.clone().diff(toDay.clone(), 'd') // ช่วงเวลาที่เหลือของอายุการใช้งาน ( 0 วันเท่ากับ วันนี้ )
  //   // console.log('timeLeft => ', timeLeft)
  //   if (!isCanRenderBuyPack) {
  //     return null
  //   }
  //   return (
  //     <VStack w={'full'} bgColor={COLORS.APP_SECONDARY} space={'1'} alignItems={'center'} justifyContent={'center'} py='2'>
  //       <HStack>
  //         <XText fontSize={'md'} bold>
  //           เพิ่มประสิทธิภาพให้การทำงานไม่สะดุด อย่างต่อเนื่อง
  //         </XText>
  //       </HStack>
  //       <XButton
  //         onPress={() => {
  //           if (timeLeft < -3) {
  //             p.op.showConfirmationOkOnly('', 'กรุณาติดต่อทีมงาน')
  //           } else {
  //             this._navToInAppPurchasePerPackageView()
  //           }
  //         }}>
  //         <XText color={COLORS.WHITE} fontSize={'md'}>
  //           ต่อแพ็กเกจ
  //         </XText>
  //       </XButton>
  //     </VStack>
  //   )
  // }

  _renderExtendPackageButton = () => {
    const { subscription } = this.props
    const AVAILABLE_TYPES = [2, 3, 4, 5]
    if (_.isNil(subscription) || !_.includes(AVAILABLE_TYPES, subscription.get('type'))) {
      return null
    }

    let isCanRenderBuyPack = true

    const end = dayjs(util.getSubcriptionEndDate(subscription)) // อายุการใช้งานงานวันสุดท้ายของแพ็กเกจ
    const toDay = dayjs(new Date())
    // console.log('end => ', end.format('DD/MM/YYYY'))
    // console.log('toDay => ', toDay.format('DD/MM/YYYY'))
    const timeLeft = end.clone().diff(toDay.clone(), 'd') // ช่วงเวลาที่เหลือของอายุการใช้งาน ( 0 วันเท่ากับ วันนี้ )
    // console.log('timeLeft => ', timeLeft)

    if (timeLeft > 20) {
      isCanRenderBuyPack = false
    }

    if (!isCanRenderBuyPack) {
      return null
    }

    const canRenderPerPackage = this._canRenderPerPackage()
    if (!canRenderPerPackage) {
      return null
    }
    return (
      <HStack flex={1} justifyContent='flex-end' alignItems='center'>
        <TouchableOpacity
          onPress={() => this._navToInAppPurchasePerPackageView()}
          style={{
            backgroundColor: COLORS.APP_MAIN,
            borderColor: COLORS.APP_MAIN,
            borderWidth: 1,
            marginTop: 4,
            borderRadius: 90,
            alignItems: 'center',
            justifyContent: 'center',
            width: 140,
          }}
        >
          <XText my='1' bold fontSize='lg' color={COLORS.WHITE}>
            ต่อแพ็กเกจ
          </XText>
        </TouchableOpacity>
      </HStack>
    )
  }

  _renderDetailsOfThisBillingCycle = () => {
    const { subscription } = this.props
    const orderCount = subscription.get('order_count_curr') || 0
    const orderQuota = subscription.get('order_count_quota') || 0
    const startBillingDate = subscription.has('start_billing_date')
      ? subscription.get('start_billing_date')
      : subscription.get('startBillingDate')
    const endBillingDate = subscription.has('end_billing_date') ? subscription.get('end_billing_date') : subscription.get('endBillingDate')
    const txtEndBillingDate = moment(endBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    const txtStartBillingDate = moment(startBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    return (
      <VStack w='full'>
        <HStack justifyContent='center' alignItems='center'>
          <XText fontSize='lg' bold>
            รอบบิลปัจจุบัน
          </XText>
        </HStack>
        <HStack flex={1}>
          <HStack flex={1}>
            <XText fontSize='md' variant='inactive'>
              จำนวนออเดอร์
            </XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText bold fontSize='md'>{`${orderCount} / ${orderQuota}`}</XText>
          </HStack>
        </HStack>
        <HStack flex={1}>
          <HStack flex={1}>
            <XText fontSize='md' variant='inactive'>
              เริ่มรอบบิล
            </XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText bold fontSize='md'>{`${txtStartBillingDate}`}</XText>
          </HStack>
        </HStack>
        <HStack flex={1}>
          <HStack flex={1}>
            <XText fontSize='md' variant='inactive'>
              สิ้นสุดรอบบิล
            </XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText bold fontSize='md'>{`${txtEndBillingDate}`}</XText>
          </HStack>
        </HStack>
        <HStack mt='1' borderBottomColor={COLORS.TEXT_INACTIVE} borderBottomWidth='1' />
      </VStack>
    )
  }

  _renderUpgradePakageUnderline = () => {
    const showUpgradeBtn = this._showUpgradePackage()
    const isOwner = acl.isSelectedStoreOwner()
    if (showUpgradeBtn === false && !isOwner) {
      return null
    }
    return (
      <HStack flex={1} justifyContent='flex-end' alignItems='center'>
        <XText
          textDecorationLine='underline'
          my='1'
          fontSize='lg'
          color={COLORS.BLUE_FACEBOOK}
          onPress={() => this._navToInAppPurchaseView('upgrade')}
        >
          อัพเกรดแพ็กเกจ
        </XText>
      </HStack>
    )
  }

  // _renderMyPackage02 = () => {
  //   const { subscription } = this.props
  //   let txtMainPackageName = ''
  //   try {
  //     if (subscription.get('type') === 999) {
  //       txtMainPackageName = this.mainPackageItems[5].label
  //     } else {
  //       txtMainPackageName = this.mainPackageItems[subscription.get('type') - 1].label
  //     }
  //   } catch (error) {
  //     txtMainPackageName = ''
  //   }
  //   const mEndDate = subscription.has('m_s_date') ? util.getSubcriptionEndDate(subscription) : null
  //   // console.log('mEndDate => ', mEndDate)
  //   // const mEndDate = util.getSubcriptionEndDate(subscription)
  //   const endDate = moment(mEndDate, SERVER_DATE_FORMAT)
  //   const txtMainPackageEnd = endDate.clone().format(LOCAL_DATE_FORMAT)
  //   const txtExpireMainPackageIn = endDate.clone().fromNow()
  //   return (
  //     <VStack w='full'>
  //       <HStack alignItems='center' justifyContent='center'>
  //         <XText fontSize='lg' bold>
  //           แพ็กเกจของฉัน
  //         </XText>
  //       </HStack>
  //       {/* <HStack>
  //         <XText fontSize={'md'} bold>
  //           {`แพ็กเกจ ${txtMainPackageName}`}
  //         </XText>
  //       </HStack> */}
  //       <HStack flex={1}>
  //         <HStack flex={1}>
  //           <XText variant='inactive' fontSize='md'>
  //             แพ็กเกจ
  //           </XText>
  //         </HStack>
  //         <HStack flex={2} justifyContent='flex-end'>
  //           <XText fontSize='md' bold>
  //             {`${txtMainPackageName}`}
  //           </XText>
  //         </HStack>
  //       </HStack>
  //       {_.isNil(mEndDate) ? null : (
  //         <HStack flex={1}>
  //           <HStack flex={1}>
  //             <XText variant='inactive' fontSize='md'>
  //               ใช้งานได้ถึง
  //             </XText>
  //           </HStack>
  //           <HStack flex={2} justifyContent='flex-end'>
  //             <XText fontSize='md' bold>{`${txtMainPackageEnd} (${txtExpireMainPackageIn})`}</XText>
  //           </HStack>
  //         </HStack>
  //       )}

  //       {this._renderBuyNewPackageButton()}
  //       {this._renderExtendPackageButton()}
  //       {/* {this._renderUpgradePakageUnderline()} */}
  //       <HStack mt='3.5' borderBottomColor={COLORS.TEXT_INACTIVE} borderBottomWidth='1' />
  //     </VStack>
  //   )
  // }

  _renderMyPackageDetails = () => {
    const { subscription } = this.props
    // const { packageDetails } = this.state
    // console.log('packageDetails => ', packageDetails)
    if (_.isNil(subscription)) {
      return null
    }
    const type = subscription.get('type')
    // console.log('type // => ', type)
    return <XUISubcriptionDetail subscription={subscription.toJS()} type={type} />
    // const itemPackageDetails = JSON_PACKAGE_DETAIL_DATA.items_package_detail
    // return (
    //   <VStack w='full'>
    //     {itemPackageDetails.map((section, idx) => {
    //       const sectionName = section.section_name
    //       return (
    //         <VStack>
    //           <VStack justifyContent={'flex-start'} w='full' mt='2' key={`section_${idx}`}>
    //             <XText bold fontSize={'md'}>
    //               {sectionName}
    //             </XText>
    //             {section.items.map((item, indexMap) => {
    //               const availableTypes = item?.available_types
    //               // const abc = indexMap === 1 ? '1' : '99,999'
    //               const countPackage = item?.key ? this._getCountPackageByKey(item.key) : null
    //               const packageActive = !_.isNil(availableTypes) && availableTypes.includes(subscription.get('type'))

    //               let RENDER_ICON = (
    //                 <HStack justifyContent={'center'} w='32'>
    //                   <XIcon name='close-circleo' family='AntDesign' color={COLORS.RED} />
    //                 </HStack>
    //               )
    //               if (packageActive) {
    //                 RENDER_ICON = (
    //                   <HStack justifyContent={'center'} w='32'>
    //                     <XIcon name='check-circle-o' family='AntDesign' color={COLORS.GREEN} />
    //                   </HStack>
    //                 )
    //               }
    //               return (
    //                 <HStack w='full' mt='2' space={'1'} key={`item_${indexMap}`}>
    //                   <HStack flex={1}>
    //                     <XText variant='inactive' fontSize={'md'}>
    //                       {item.name}
    //                     </XText>
    //                   </HStack>
    //                   {_.isNil(availableTypes) && !p.op.isIOS() ? (
    //                     <HStack justifyContent={'flex-end'} w='10'>
    //                       <XText
    //                         variant='inactive'
    //                         color={COLORS.BRAND_Info}
    //                         fontSize={'md'}
    //                         onPress={() => p.op.showConfirmationOkOnly('', 'กรุณาติดต่อทีมงาน')}>
    //                         {'เพิ่ม?'}
    //                       </XText>
    //                     </HStack>
    //                   ) : null}
    //                   {_.isNil(availableTypes) ? (
    //                     <HStack justifyContent={'center'} w='32'>
    //                       <XText variant='active' bold fontSize={'md'}>{`${countPackage} ${item.unit}`}</XText>
    //                     </HStack>
    //                   ) : (
    //                     RENDER_ICON
    //                   )}
    //                 </HStack>
    //               )
    //             })}
    //           </VStack>
    //           <HStack borderBottomColor={COLORS.TEXT_INACTIVE} borderBottomWidth={'1'} mt='2' />
    //         </VStack>
    //       )
    //     })}
    //   </VStack>
    // )
  }

  _renderBtnAction = () => {
    // const isDevMode = util.isDevMode()
    // if (!isDevMode) {
    //   return null
    // }
    const { pendingOrderData } = this.state
    const { subscription } = this.props
    const type = subscription.get('type')
    // console.log('type => ', type)
    if (type === 1 || type === 999 || !_.isNil(pendingOrderData)) {
      return null
    }
    const showUpgradeBtn = this._showUpgradePackage()
    const showAddOnBtn = this._showAddonBtn()
    const isOwner = acl.isSelectedStoreOwner()
    if (!isOwner) {
      return null
    }
    return (
      <HStack flex={1} alignItems='center' justifyContent='flex-end' px='2' pb='2' mt='1'>
        {showUpgradeBtn ? (
          <TouchableOpacity
            onPress={() => this._navToInAppPurchaseView('upgrade')}
            style={{
              marginRight: 10,
              width: 140,
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 90,
              backgroundColor: '#E4EAEF',
            }}
          >
            <XText bold fontSize='md' my='2'>
              อัพเกรดแพ็กเกจ
            </XText>
          </TouchableOpacity>
        ) : null}
        {showAddOnBtn ? (
          <TouchableOpacity
            onPress={() => this._navToBuyAddOnPackage()}
            style={{
              width: 140,
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 90,
              backgroundColor: '#E7DED9',
            }}
          >
            <XText bold fontSize='md' my='2'>
              ซื้อแพ็กเสริม
            </XText>
          </TouchableOpacity>
        ) : null}
      </HStack>
    )
  }

  _renderNextBillingCycle = () => {
    const { subscription } = this.props
    const { subscriptionPackageList } = this.state
    if (_.isNil(subscriptionPackageList)) {
      return null
    }
    let startBillingDate = subscription.has('start_billing_date')
      ? subscription.get('start_billing_date')
      : subscription.get('startBillingDate')
    let endBillingDate = subscription.has('end_billing_date') ? subscription.get('end_billing_date') : subscription.get('endBillingDate')

    const endPackage = util.getSubcriptionEndDate(subscription)
    // console.log('endPackage => ', endPackage)

    const timeLeft = dayjs(endBillingDate).clone().diff(dayjs(), 'h')
    const nextBillingTimeLeft = dayjs(endPackage).clone().diff(dayjs(endBillingDate), 'd')
    // console.log('nextBillingTimeLeft => ', nextBillingTimeLeft)
    if (timeLeft > 23 && nextBillingTimeLeft < 1) {
      return null
    }

    const { future_billing_dates } = subscriptionPackageList
    startBillingDate = future_billing_dates[0].start
    endBillingDate = future_billing_dates[0].end

    const txtEndBillingDate = moment(endBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    const txtStartBillingDate = moment(startBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    return (
      <XCard m='2' mt='0' h='20'>
        <VStack w='full'>
          <HStack h='10' alignItems='center' justifyContent='center'>
            <XText bold fontSize='lg'>
              รอบบิลถัดไป
            </XText>
          </HStack>
          <VStack px='2' h='12'>
            <HStack>
              <HStack flex={1}>
                <XText fontSize='md' variant='inactive'>
                  ช่วงเวลา
                </XText>
              </HStack>
              <HStack flex={3} justifyContent='flex-end'>
                <XText fontSize='md' variant='inactive'>{`${txtStartBillingDate} - ${txtEndBillingDate}`}</XText>
              </HStack>
            </HStack>
          </VStack>
        </VStack>
      </XCard>
    )
  }

  _renderCurrentBillingCycle = () => {
    const { subscription } = this.props
    return (
      <XCard m='2'>
        {renderCurrentBillingCycle(subscription)}
        {this._renderBtnAction()}
      </XCard>
    )
  }

  _renderNowPackage = () => {
    const { subscription } = this.props
    // console.log('subscription => ', subscription.toJS())
    let txtMainPackageName = ''
    try {
      if (subscription.get('type') === 999) {
        txtMainPackageName = this.mainPackageItems[5].label
      } else {
        txtMainPackageName = this.mainPackageItems[subscription.get('type') - 1].label
      }
    } catch (error) {
      txtMainPackageName = ''
    }

    const currentPackageBillingCycle = subscription.has('current_package_billing_cycle')
      ? subscription.get('current_package_billing_cycle').toJS()
      : null
    const currentPackageData = this._getCurentPackage(currentPackageBillingCycle)
    let startPackage = null
    let endPackage = null
    if (!_.isNil(currentPackageData)) {
      startPackage = dayjs(currentPackageData.start_date, SERVER_DATE_FORMAT).clone().format(LOCAL_DATE_FORMAT)
      endPackage = dayjs(currentPackageData.end_date, SERVER_DATE_FORMAT).clone().format(LOCAL_DATE_FORMAT)
    }

    return (
      <XCard m='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} h='10' alignItems='center' justifyContent='center' w='full'>
          <XText bold fontSize='lg'>
            แพ็กเกจปัจจุบัน
          </XText>
        </HStack>

        <VStack p='2'>
          <XText bold fontSize='lg'>{`แพ็กเกจ ${txtMainPackageName}`}</XText>

          {!_.isNil(currentPackageData) ? (
            <HStack h='6'>
              <HStack flex={1}>
                <XText fontSize='md' variant='inactive'>
                  {`${currentPackageData.billing_cycle} รอบบิล`}
                </XText>
              </HStack>
              <HStack flex={2} justifyContent='flex-end'>
                <XText fontSize='md' variant='inactive'>{`${startPackage} - ${endPackage}`}</XText>
              </HStack>
            </HStack>
          ) : null}

          <HStack flex={1} alignItems='center' justifyContent='flex-end'>
            <XText color={COLORS.TEXT_INACTIVE} bold textDecorationLine='underline' onPress={() => this._navToActivePackageDetailView()}>
              ดูรายละเอียด
            </XText>
          </HStack>
        </VStack>

        {this._renderCurrentBillingCycle()}
        {/* {this._renderNextBillingCycle()} */}
      </XCard>
    )
  }

  _renderBtnBuyPackage = () => {
    const { pendingOrderData } = this.state
    const isCanRenderBuyPack = util.showBtnBuyPackage()
    // console.log('isCanRenderBuyPack => ', isCanRenderBuyPack)
    if (isCanRenderBuyPack === false || !_.isNil(pendingOrderData)) {
      return null
    }
    const { subscription } = this.props
    const type = subscription.get('type')
    const mode = 'buy_package'
    const textLabel = 'ซื้อแพ็กเกจ'
    return (
      <HStack alignItems='center' justifyContent='flex-end'>
        {RenderBtnCallActionPackage(textLabel, () => {
          // ถ้าเป็นแพ็กทดลองให้คิดว่าเป้นการต่อแพ็กเกจ ไม่ใช่การซื้อแพ็กเกจ
          if (_.isNil(pendingOrderData) && type !== 999) {
            this._navToInAppPurchaseView(mode)
          } else {
            // ถ้า type !== 999 ให้ส่ง buy_package เป็น default เพื่อให้หน้าถัดไป init ข้อมูลให้ถูกต้อง
            // ถ้า type === 999 ให้ส่ง continue_package เป็น default เพื่อให้หน้าถัดไป init ข้อมูลให้ถูกต้อง
            this._navToSelectedSubscriptionPackageView(type !== 999 ? 'buy_package' : 'continue_package')
          }
        })}
      </HStack>
    )
  }

  _renderBtnPerPackage = () => {
    const { subscription } = this.props
    const canRenderPerPackage = this._showBtnPerPackage()
    //  if (!canRenderPerPackage || !_.isNil(pendingOrderData)) {
    //   return null
    // }
    const type = subscription.get('type')
    // แพ็กทดลองใช้ จะใช้ปุ่มซื้อแพ็กเกจแทน
    if (!canRenderPerPackage || type === xCONS.SUBSCRIPTION_PACKAGE.TRIAL) {
      return null
    }

    return (
      <VStack>
        <HStack alignItems='center' justifyContent='flex-end'>
          {RenderBtnCallActionPackage('ต่อแพ็กเกจ', () => this._navToInAppPurchasePerPackageView())}
        </HStack>
      </VStack>
    )
  }

  _renderNextPackage = () => {
    const { subscription } = this.props
    const { subscriptionPackageList } = this.state
    const LastBillingCycle = util.getSubscriptionNextLastBillingCycle(subscription)
    if (_.isNil(LastBillingCycle) || _.isNil(subscriptionPackageList)) {
      return null
    }

    const selectedPackage = util.getSubscriptionPackageJsonBySku(LastBillingCycle.sku, subscriptionPackageList)
    if (_.isNil(selectedPackage)) {
      return null
    }
    const subscriptionType = util.getSubscriptionPackageTypeByPackageName(selectedPackage.item_subtype)
    const txtMainPackageName = util.getSubscriptionTypeFullName(subscriptionType)
    let startPackage = null
    let endPackage = null
    if (!_.isNil(LastBillingCycle)) {
      startPackage = dayjs(LastBillingCycle.start_date, SERVER_DATE_FORMAT).clone().format(LOCAL_DATE_FORMAT)
      endPackage = dayjs(LastBillingCycle.end_date, SERVER_DATE_FORMAT).clone().format(LOCAL_DATE_FORMAT)
    }

    return (
      <XCard m='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} h='10' alignItems='center' justifyContent='center' w='full'>
          <XText bold fontSize='lg'>
            แพ็กเกจถัดไป
          </XText>
        </HStack>

        <VStack p='2' bgColor='#FEF0E9'>
          <XText bold fontSize='lg'>{`แพ็กเกจ ${txtMainPackageName}`}</XText>

          <HStack h='6'>
            <HStack flex={1}>
              <XText fontSize='md' variant='inactive'>
                {`${LastBillingCycle.billing_cycle} รอบบิล`}
              </XText>
            </HStack>
            <HStack flex={2} justifyContent='flex-end'>
              <XText fontSize='md' variant='inactive'>{`${startPackage} - ${endPackage}`}</XText>
            </HStack>
          </HStack>

          <HStack flex={1} alignItems='center' justifyContent='flex-end'>
            <XText color={COLORS.TEXT_INACTIVE} bold textDecorationLine='underline' onPress={() => this._navToNextPackageDetailView()}>
              ดูรายละเอียด
            </XText>
          </HStack>
        </VStack>
      </XCard>
    )
  }

  _renderMyPackage = () => {
    const { subscription } = this.props
    // const startBillingDate = subscription.get('startBillingDate') || moment()
    // const endBillingDate = subscription.get('endBillingDate') || moment()
    // const orderCount = subscription.get('order_count_curr') || 0
    // const orderQuota = subscription.get('order_count_quota') || 0
    // const mainPackageOrderQuota = subscription.get('order_count_quota') || 0
    // const ugGroups = subscription.get('ug_quota')
    // const pgGroups = subscription.get('pg_quota')
    // let colorOrderQuota = TEXT_ACTIVE
    // const orderCountPerQuota = orderCount / orderQuota
    // if (orderCountPerQuota >= orderDangerInPercentage) {
    //   colorOrderQuota = BRAND_Danger
    // } else if (orderCountPerQuota >= orderWarningInPercentage) {
    //   colorOrderQuota = BRAND_Warning
    // }
    // const dEnd = moment(endBillingDate, SERVER_DATE_FORMAT)
    // const txtEndBillingIn = dEnd.clone().fromNow()
    // const txtStartBillingDate = moment(startBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    // const txtEndBillingDate = moment(endBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    // package detail
    // const packages = subscription.get('packages')

    // let txtMainPackageName = this.mainPackageItems[0].label
    // let txtMainPackageBegin = null
    let txtMainPackageEnd = null
    let txtExpireMainPackageIn = null
    // let colorExpireMainPackageIn = TEXT_ACTIVE

    // const packageId = subscription.get('type') || 1
    // const currentPackage = this.mainPackageItems.find((item) => item.value === packageId)

    // if (currentPackage && currentPackage.label) {
    //   txtMainPackageName = currentPackage.label
    // }
    const mBeginDate = subscription.has('m_s_date') ? subscription.get('m_s_date') : null
    const mEndDate = util.getSubcriptionEndDate(subscription)
    // if (mBeginDate) {
    //   // txtMainPackageBegin = moment(mBeginDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    // }
    // console.log('mEndDate => ', mEndDate)
    if (mBeginDate) {
      const endDate = dayjs(mEndDate)
      txtMainPackageEnd = endDate.clone().format(LOCAL_DATE_FORMAT)
      txtExpireMainPackageIn = endDate.clone().fromNow()

      // Check dayToExpire for warning color
      // const dayToExpire = endDate.clone().diff(moment(), 'days')
      // if (dayToExpire > expireDangerInDay && dayToExpire < expireWarningInDay) {
      //   // colorExpireMainPackageIn = BRAND_Warning
      // } else if (dayToExpire <= expireDangerInDay) {
      //   // colorExpireMainPackageIn = BRAND_Danger
      // }
    }

    // const mEndDate = subscription.has('m_s_date') ? subscription.get('m_e_date') : null
    const isOwner = acl.isSelectedStoreOwner()
    return (
      <XCard m='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} h='10' alignItems='center' justifyContent='center' w='full'>
          <XText bold fontSize='lg'>
            แพ็กเกจของฉัน
          </XText>
        </HStack>
        <VStack p='2' w='full'>
          {_.isNil(mEndDate) ? null : (
            <HStack h='8'>
              <HStack flex={1}>
                <XText variant='inactive' fontSize='md'>
                  ใช้งานได้ถึง
                </XText>
              </HStack>
              <HStack flex={2} justifyContent='flex-end'>
                <XText fontSize='md' bold>{`${txtMainPackageEnd} (${txtExpireMainPackageIn})`}</XText>
              </HStack>
            </HStack>
          )}
          {isOwner ? this._renderBtnBuyPackage() : null}
          {isOwner ? this._renderBtnPerPackage() : null}
        </VStack>
        <VStack w='full'>
          {this._renderNextPackage()}
          {this._renderNowPackage()}
        </VStack>
      </XCard>
    )
  }

  _renderPackageDetails = () => {
    // const isNoobIos = util.isIosNoobCheckByPass()
    // if (isNoobIos) {
    //   return null
    // }
    const { subscription } = this.props
    return (
      <VStack p='2' w='full' bgColor={COLORS.WHITE}>
        <VStack p='2' borderRadius='md' borderWidth='1' borderColor={COLORS.TEXT_INACTIVE}>
          {/* {this._renderMyPackage02()} */}
          {this._renderPackageAllDetails()}
        </VStack>
      </VStack>
    )
  }

  _renderPackageAllDetails = () => (
    // isNoobIos = https://app.clickup.com/t/86cvy20nq
    // const isNoobIos = util.isIosNoobCheckByPass()
    // if (isNoobIos) {
    //   return null
    // }
    <VStack>
      {this._renderDetailsOfThisBillingCycle()}
      {this._renderMyPackageDetails()}
    </VStack>
  )

  _renderOldPackageDetail = () => {
    const { profile, subscription } = this.props
    if (!subscription || !subscription.get('user_id')) {
      return (
        <XSpinner
          style={{
            flex: 1,
            width: '100%',
            paddingVertical: 10,
            backgroundColor: APP_SECONDARY,
          }}
          color={APP_MAIN}
        />
      )
    }
    // subscription detail
    // const billingDate = subscription.get('billing_date') || moment()
    const startBillingDate = subscription.get('startBillingDate') || moment()
    const endBillingDate = subscription.get('endBillingDate') || moment()
    const orderCount = subscription.get('order_count_curr') || 0
    const orderQuota = subscription.get('order_count_quota') || 0
    const mainPackageOrderQuota = subscription.get('order_count_quota') || 0
    const ugGroups = subscription.get('ug_quota')
    const pgGroups = subscription.get('pg_quota')
    let colorOrderQuota = TEXT_ACTIVE
    const orderCountPerQuota = orderCount / orderQuota
    if (orderCountPerQuota >= orderDangerInPercentage) {
      colorOrderQuota = BRAND_Danger
    } else if (orderCountPerQuota >= orderWarningInPercentage) {
      colorOrderQuota = BRAND_Warning
    }
    const dEnd = moment(endBillingDate, SERVER_DATE_FORMAT)
    const txtEndBillingIn = dEnd.clone().fromNow()
    const txtStartBillingDate = moment(startBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    const txtEndBillingDate = moment(endBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    // package detail
    const packages = subscription.get('packages')

    let txtMainPackageName = this.mainPackageItems[0].label
    let txtMainPackageBegin = null
    let txtMainPackageEnd = null
    let txtExpireMainPackageIn = null
    let colorExpireMainPackageIn = TEXT_ACTIVE

    const packageId = subscription.get('type') || 1
    const currentPackage = this.mainPackageItems.find((item) => item.value === packageId)

    if (currentPackage && currentPackage.label) {
      txtMainPackageName = currentPackage.label
    }
    const mBeginDate = subscription.has('m_s_date') ? subscription.get('m_s_date') : null
    const mEndDate = subscription.has('m_s_date') ? subscription.get('m_e_date') : null

    if (mBeginDate) {
      txtMainPackageBegin = moment(mBeginDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    }
    if (mBeginDate) {
      const endDate = moment(mEndDate, SERVER_DATE_FORMAT)
      txtMainPackageEnd = endDate.clone().format(LOCAL_DATE_FORMAT)
      txtExpireMainPackageIn = endDate.clone().fromNow()

      // Check dayToExpire for warning color
      const dayToExpire = endDate.clone().diff(moment(), 'days')
      if (dayToExpire > expireDangerInDay && dayToExpire < expireWarningInDay) {
        colorExpireMainPackageIn = BRAND_Warning
      } else if (dayToExpire <= expireDangerInDay) {
        colorExpireMainPackageIn = BRAND_Danger
      }
    }
    return (
      <VStack>
        {this._hideObject() ? null : (
          <XCard>
            <XCard.Body style={{ justifyContent: 'center', alignItems: 'center' }}>
              <XText fontSize='md' bold>
                รายละเอียดรอบเดือนนี้
              </XText>
            </XCard.Body>
            <XCard.Body>
              <VStack flex={1}>
                {/* <SRowItem */}
                {/* label='แพ็กเกจปัจจุบัน' */}
                {/* desc={ txtMainPackageName } */}
                {/* descStyle={{ color: BRAND_Success }} */}
                {/* /> */}
                <HStack bgColor={APP_SECONDARY} px='2' py='1'>
                  <VStack flex={7}>
                    <XText>ออเดอร์ขาย</XText>
                    <XText variant='inactive'>ที่ฉันเปิดโดยมีสินค้าฉันสต็อก</XText>
                    <XText style={{ flex: 1, textAlign: 'left', paddingLeft: 25, fontWeight: 'bold' }}>+</XText>
                    <XText>ออเดอร์ขาย</XText>
                    <XText variant='inactive'>ที่ตัวแทนเปิดมาให้ฉัน</XText>
                  </VStack>
                  <HStack flex={3} alignItems='center'>
                    <XText
                      style={{
                        flex: 1,
                        textAlign: 'right',
                      }}
                    >
                      {`${orderCount}/${orderQuota}`}
                    </XText>
                  </HStack>
                </HStack>
                <HStack mt='1' />
                <SRowItem label='วันที่เริ่มรอบเดือน' desc={txtStartBillingDate} />
                <SRowItem label='วันที่สิ้นสุดรอบเดือน' desc={txtEndBillingDate} />
                <SRowItem desc={`(${txtEndBillingIn})`} descStyle={{ fontSize: FONT_SIZE_SMALLER, color: TEXT_INACTIVE }} />
              </VStack>
            </XCard.Body>
          </XCard>
        )}
        <XCard mt='2'>
          {this._hideObject() ? null : (
            <XCard.Body style={{ justifyContent: 'center', alignItems: 'center' }}>
              <XText bold>แพ็กเกจของฉัน</XText>
            </XCard.Body>
          )}

          <XCard.Body>
            <View style={{ flex: 1 }}>
              {this._hideObject() ? null : (
                <SRowItem label='ชื่อแพ็กเกจ' desc={txtMainPackageName} descStyle={{ color: TEXT_ACTIVE, fontWeight: 'bold' }} />
              )}
              {/* <SRowItem */}
              {/* label='ได้รับโควต้าออเดอร์ขายต่อเดือน' */}
              {/* desc={ mainPackageOrderQuota } */}
              {/* /> */}
              {/* <SRowItem */}
              {/* label='ที่ตัวแทนฉันเปิดมา + ที่ฉันเปิดโดยมีสินค้าฉันสต็อก' */}
              {/* labelStyle={{ fontSize: FONT_SIZE_SMALLER, color: TEXT_INACTIVE }} */}
              {/* /> */}
              {/* <SRowItem */}
              {/* label='ออเดอร์ซื้อที่ฉันเปิดให้ร้านขายส่ง' */}
              {/* desc={ 'ไม่จำกัด' } */}
              {/* descStyle={{ color: BRAND_Success, fontWeight: 'bold' }} */}
              {/* /> */}
              {/* <SRowItem */}
              {/* label='ออเดอร์ขายที่ไม่มีสินค้าฉันสต็อก' */}
              {/* desc={ 'ไม่จำกัด' } */}
              {/* descStyle={{ color: BRAND_Success, fontWeight: 'bold' }} */}
              {/* /> */}

              <View
                style={{
                  flex: 1,
                  paddingHorizontal: 8,
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <View style={{ flex: 8 }}>
                  <View style={{ flex: 1, flexDirection: 'row' }}>
                    <XText>จำนวนสมาชิก</XText>
                  </View>
                </View>
                <View style={{ flex: 2, flexDirection: 'row', alignItems: 'center' }}>
                  <XText flex={1} variant='success' textAlign='right' fontSize='md' bold>
                    ไม่จำกัด
                  </XText>
                </View>
              </View>

              <View
                style={{
                  flex: 1,
                  paddingHorizontal: 8,
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <View style={{ flex: 8 }}>
                  <View style={{ flex: 1, flexDirection: 'row' }}>
                    <XText>ออเดอร์ซื้อ</XText>
                  </View>
                </View>
                <View style={{ flex: 2, flexDirection: 'row', alignItems: 'center' }}>
                  <XText flex={1} variant='success' bold textAlign='right'>
                    ไม่จำกัด
                  </XText>
                </View>
              </View>

              <HStack w='full' px='2'>
                <VStack flex={8}>
                  <XText>ออเดอร์ขาย</XText>
                  <XText variant='inactive'>ที่ฉันเปิดโดยไม่มีสินค้าฉันสต็อก</XText>
                </VStack>
                <HStack flex={2} alignItems='center'>
                  <XText flex={1} variant='success' bold textAlign='right'>
                    ไม่จำกัด
                  </XText>
                </HStack>
              </HStack>

              {/* <View
                  style={{
                    flex: 1,
                    paddingHorizontal: 8,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}>
                  <View style={{ flex: 8 }}>
                    <XText>ออเดอร์ขาย</XText>
                    <XText variant='inactive'>ที่ฉันเปิดโดยไม่มีสินค้าฉันสต็อก</XText>
                  </View>
                  <View style={{ flex: 2, flexDirection: 'row', alignItems: 'center' }}>
                    <XText flex={1} variant='success' bold textAlign='right'>
                      ไม่จำกัด
                    </XText>
                  </View>
                </View> */}

              {this._hideObject() ? null : (
                <HStack bgColor={APP_SECONDARY} px='2' py='1'>
                  <VStack flex={7}>
                    <XText>ออเดอร์ขาย</XText>
                    <XText variant='inactive'>ที่ฉันเปิดโดยมีสินค้าฉันสต็อก</XText>
                    <XText style={{ flex: 1, textAlign: 'left', paddingLeft: 25, fontWeight: 'bold' }}>+</XText>
                    <XText>ออเดอร์ขาย</XText>
                    <XText variant='inactive'>ที่ตัวแทนเปิดมาให้ฉัน</XText>
                  </VStack>
                  <HStack flex={3} alignItems='center'>
                    <XText
                      style={{
                        flex: 1,
                        textAlign: 'right',
                      }}
                    >
                      {mainPackageOrderQuota}
                      /เดือน
                    </XText>
                  </HStack>
                </HStack>
              )}

              {/* {Platform.OS === 'ios' ? ( */}
              {/* <View */}
              {/* style={{ */}
              {/* flex: 1, */}
              {/* paddingHorizontal: 16, */}
              {/* paddingVertical: 4, */}
              {/* marginVertical: 4, */}
              {/* flexDirection: 'row', */}
              {/* justifyContent: 'space-between', */}
              {/* }}> */}
              {/* <XText style={{ fontSize: FONT_SIZE_NORMAL, color: APP_MAIN }}> */}
              {/* กรุณาเช็กที่เว็ปไซด์ของเราสำหรับรายละเอียดแพ็กเกจเพิ่มเติม */}
              {/* </XText> */}
              {/* </View> */}
              {/* ) : null} */}

              {/* <SRowItem */}
              {/* label='เริ่มใช้งานวันที่' */}
              {/* desc={ txtMainPackageBegin } */}
              {/* /> */}
              {/* <SRowItem */}
              {/* label='ใช้ได้ถึงวันที่' */}
              {/* desc={ txtMainPackageEnd } */}
              {/* /> */}
              {/* <SRowItem */}
              {/* label='จะหมดอายุภายใน' */}
              {/* desc={ txtExpireMainPackageIn } */}
              {/* descStyle={{ color: colorExpireMainPackageIn }} */}
              {/* /> */}
              <HStack mt='2' />
              {txtMainPackageBegin ? <SRowItem label='เริ่มใช้งานวันที่' desc={txtMainPackageBegin} /> : null}
              {txtMainPackageEnd ? <SRowItem label='ใช้ได้ถึงวันที่' desc={txtMainPackageEnd} /> : null}
              {txtExpireMainPackageIn ? (
                <SRowItem label='จะหมดอายุภายใน' desc={txtExpireMainPackageIn} descStyle={{ color: colorExpireMainPackageIn }} />
              ) : null}
              {this._hideObject() ? null : (
                <View
                  style={{
                    flex: 1,
                    paddingHorizontal: 8,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  {/* ARTID */}
                  <View style={{ flex: 8 }}>
                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <XText>จำนวนกลุ่มสมาชิก</XText>
                    </View>
                  </View>
                  <View style={{ flex: 2, flexDirection: 'row', alignItems: 'center' }}>
                    <XText flex={1} variant='success' bold textAlign='right'>
                      {ugGroups}
                    </XText>
                  </View>
                </View>
              )}
              {this._hideObject() ? null : (
                <View
                  style={{
                    flex: 1,
                    paddingHorizontal: 8,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <View style={{ flex: 8 }}>
                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <XText>จำนวนรายการราคา</XText>
                    </View>
                  </View>
                  <View style={{ flex: 2, flexDirection: 'row', alignItems: 'center' }}>
                    <XText flex={1} variant='success' bold textAlign='right'>
                      {pgGroups}
                    </XText>
                  </View>
                </View>
              )}
            </View>
          </XCard.Body>
          {Platform.OS === 'ios' ? null : (
            <XCard.Body>
              <TouchableOpacity
                onPress={() => {
                  Linking.canOpenURL('https://www.xselly.com/pricing').then((supported) => {
                    if (supported) {
                      Linking.openURL('https://www.xselly.com/pricing')
                    }
                  })
                }}
                style={{
                  flex: 1,
                  backgroundColor: APP_MAIN,
                  borderRadius: 8,
                  height: 40,
                }}
              >
                <XText
                  flex={1}
                  textAlign='center'
                  bold
                  py='2'
                  color={TEXT_ACTIVE_DARK}
                  // style={{
                  //   flex: 1,
                  //   textAlign: 'center',
                  //   fontSize: FONT_SIZE_LARGER,
                  //   fontWeight: 'bold',
                  //   paddingVertical: 4,
                  //   color: TEXT_ACTIVE_DARK,
                  // }}
                >
                  ดูรายละเอียดแพ็กเกจทั้งหมด
                </XText>
              </TouchableOpacity>
            </XCard.Body>
          )}
        </XCard>
      </VStack>
    )
  }

  _renderWarningNotOwner = () => {
    const isOwner = acl.isSelectedStoreOwner()
    if (isOwner) {
      return null
    }
    const selectedStore = util.getSelectedStoreFromRedex()
    // console.log('selectedStore => ', selectedStore.toJS())
    return (
      <VStack bgColor={COLORS.BRAND_Warning} p='2'>
        <XText color={COLORS.WHITE} textAlign='center'>
          {`ขณะนี้คุณอยู่ในร้าน "${selectedStore.get('name')}" ในฐานะผู้ช่วยร้าน`}
        </XText>
        <XCard bgColor='#f0f9ea' mt='2' p='2'>
          <HStack>
            <HStack flex={1}>
              <XText>
                {`ต้องใช้บัญชีเจ้าของร้านในการซื้อหรือต่อแพ็กเกจเท่านั้น! ดังนั้น
\n- สำหรับการซื้อหรือต่อแพ็กเกจร้านที่คุณเป็นผู้ช่วย (เช่นร้านนี้) กรุณาติดต่อเจ้าของร้านเพื่อดำเนินการ
\n- สำหรับการซื้อหรือต่อแพ็กเกจร้านที่คุณเป็นเจ้าของ กรุณาเปลื่ยนไปที่ร้านที่คุณเป็นเจ้าของก่อนเพื่อดำเนินการ
\n โดยข้อมูลในหน้าแพ็กเกจของฉันนี้เป็น รายละเอียดแพ็กเกจของคุณเอง (ไม่ใช่ของเจ้าของร้านนี้ที่คุณเป็นผู้ช่วยอยู่)`}
              </XText>
            </HStack>
          </HStack>
        </XCard>
      </VStack>
    )
  }

  _renderWarningPerPackage = () => {
    const { subscriptionPackangWaring, pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      return null
    }
    if (_.isNil(subscriptionPackangWaring) || subscriptionPackangWaring.ms === '') {
      return null
    }
    const showBtnPerPackage = util.showBtnPerPackage()
    // if (_.isNil(showBtnPerPackage)) {
    //   return null
    // }
    const { subscription } = this.props
    const subscriptionJS = isImmutable(subscription) ? subscription.toJS() : subscription
    const isOwner = acl.isSelectedStoreOwner()
    if (_.has(subscriptionJS, 'next_package_billing_cycle') && !isOwner) {
      return null
    }
    return (
      <VStack bgColor={subscriptionPackangWaring.bg} p='2'>
        <XText color={COLORS.WHITE} textAlign='center'>
          {subscriptionPackangWaring.ms}
        </XText>
        <XCard bgColor='#f0f9ea' mt='2' p='2'>
          <HStack>
            <HStack flex={1}>
              <XText>
                ต่อแพ็กเกจได้เลย เพื่อการใช้งานต่อเนื่องไม่มีสะดุด หากต่อก่อนแพ็กเดิมหมด ระบบก็จะรอจนหมดแพ็กเดิม
                แล้วค่อยเริ่มแพ็กใหม่ต่อให้ในวันถัดไป โดยอัตโนมัติแบบไร้รอยต่อ
              </XText>
            </HStack>
            {showBtnPerPackage ? (
              <HStack w='125px' justifyContent='flex-start'>
                {RenderBtnCallActionPackage('ต่อแพ็กเกจ', () => this._navToInAppPurchasePerPackageView())}
              </HStack>
            ) : null}
          </HStack>
        </XCard>
      </VStack>
    )
  }

  _renderWarningOrderQuota = () => {
    const { subscription } = this.props
    const { subscriptionOrderWaring, pendingOrderData } = this.state
    if (_.isNil(subscriptionOrderWaring) || !_.isNil(pendingOrderData)) {
      return null
    }
    const showUpgradeBtn = this._showUpgradePackage()
    // const { subscription } = this.props
    // const IS_ADDON_PURCHASABLE = subscription.get('is_addon_purchasable')
    const showAddOnBtn = this._showAddonBtn()
    const type = subscription.get('type')
    const warningMsg =
      type === 1
        ? 'กดปุ่ม "ซื้อแพ็กเกจ" เพื่อเลือกแพ็กเกจให้เหมาะสมได้ตามความต้องการของคุณได้เลย'
        : 'กดปุ่ม "อัพเกรดแพ็กเกจ" หรือ "ซื้อแพ็กเสริม" เพื่อเพิ่มโควตาการใช้งานของรอบบิลที่เหลืออยู่ให้เหมาะสมต่อการใช้งานของคุณได้เลย'
    // console.log('type => ', type)
    const isOwner = acl.isSelectedStoreOwner()
    if (!isOwner) {
      return null
    }
    return (
      <VStack bgColor={subscriptionOrderWaring.bg} p='2'>
        <XText color={COLORS.WHITE} textAlign='center'>
          {subscriptionOrderWaring.ms}
        </XText>

        <XCard bgColor='#f0f9ea' mt='2' p='2'>
          <HStack>
            <HStack flex={1} mr='2'>
              <XText textAlign='left'>{warningMsg}</XText>
            </HStack>
            {showUpgradeBtn && isOwner ? (
              <HStack w='140px' justifyContent='flex-start'>
                <TouchableOpacity
                  onPress={() => this._navToInAppPurchaseView('upgrade')}
                  style={{
                    width: 140,
                    height: 50,
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 90,
                    backgroundColor: '#E4EAEF',
                    alignSelf: 'flex-start',
                  }}
                >
                  <XText bold fontSize='md' my='2'>
                    อัพเกรดแพ็กเกจ
                  </XText>
                </TouchableOpacity>
              </HStack>
            ) : null}
          </HStack>

          {showAddOnBtn && isOwner ? (
            <HStack mt='8'>
              <HStack flex={1} mr='2'>
                <XText textAlign='left'>ซื้อแพ็กเสริม เพื่อเพิ่มโควตาการใช้งาน</XText>
              </HStack>
              <HStack w='140px' justifyContent='flex-end'>
                <TouchableOpacity
                  onPress={() => this._navToBuyAddOnPackage()}
                  style={{
                    width: 140,
                    height: 50,
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 90,
                    backgroundColor: '#E7DED9',
                    alignSelf: 'flex-start',
                  }}
                >
                  <XText bold fontSize='md' my='2'>
                    ซื้อแพ็กเสริม
                  </XText>
                </TouchableOpacity>
              </HStack>
            </HStack>
          ) : null}
        </XCard>
      </VStack>
    )
  }

  _renderWarningOverQuota = () => {
    const { subscriptionAllQuotaWaring } = this.state
    if (_.isNil(subscriptionAllQuotaWaring)) {
      return null
    }
    // const showBtnPerPackage = util.isDevMode()
    // // console.log('showBtnPerPackage => ', showBtnPerPackage)
    // if (_.isNil(showBtnPerPackage)) {
    //   return null
    // }
    const { subscription } = this.props
    const type = subscription.get('type')
    const showUpgradeBtn = this._showUpgradePackage()
    const showAddOnBtn = this._showAddonBtn()

    const isOwner = acl.isSelectedStoreOwner()
    if (!isOwner) {
      return null
    }
    return (
      <VStack bgColor={subscriptionAllQuotaWaring.bg} p='2'>
        <XText color={COLORS.WHITE} textAlign='center'>
          {subscriptionAllQuotaWaring.ms}
        </XText>
        <XCard bgColor='#f0f9ea' mt='2' p='2'>
          <HStack w='full'>
            <HStack flex={1} mr='2'>
              <XText textAlign='left'>อัพเกรดเป็นแพ็กเพื่อเพิ่มโควตาการใช้งาน</XText>
            </HStack>
            <HStack w='140px' justifyContent='flex-end' alignItems={'flex-end'}>
              {showUpgradeBtn && isOwner ? (
                <TouchableOpacity
                  onPress={() => this._navToInAppPurchaseView('upgrade')}
                  style={{
                    width: 140,
                    height: 50,
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 90,
                    backgroundColor: '#E4EAEF',
                    alignSelf: 'flex-start',
                  }}
                >
                  <XText bold fontSize='md' my='2'>
                    อัพเกรดแพ็กเกจ
                  </XText>
                </TouchableOpacity>
              ) : null}
            </HStack>
          </HStack>

          {type !== 1 && isOwner ? (
            <HStack mt='8'>
              <HStack flex={1} mr='2'>
                <XText textAlign='left'>ซื้อแพ็กเสริม เพื่อเพิ่มโควตาการใช้งาน</XText>
              </HStack>
              <HStack w='140px' justifyContent='flex-end'>
                {showAddOnBtn ? (
                  <TouchableOpacity
                    onPress={() => this._navToBuyAddOnPackage()}
                    style={{
                      width: 140,
                      height: 50,
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 90,
                      backgroundColor: '#E7DED9',
                      alignSelf: 'flex-start',
                    }}
                  >
                    <XText bold fontSize='md' my='2'>
                      ซื้อแพ็กเสริม
                    </XText>
                  </TouchableOpacity>
                ) : null}
              </HStack>
            </HStack>
          ) : null}
        </XCard>
      </VStack>
    )
  }

  _onTestUploadPress = async () => {
    // @ts-ignore มันคือ IXSellyFile แต่ไม่ได้ประกาศใน state
    const { selectedFile, uploadedUrl } = this.state
    // console.log('_onTestUploadPress selectedFile', selectedFile)

    try {
      // console.log('_onTestUploadPress file', selectedFile)
      const uploadResponse = await upload.uploadFile(selectedFile as IXSellyFile, { fileName: 'yoyoyo', folderPath: 'test/' })

      // @ts-ignore
      this.setState({ uploadedUrl: uploadResponse.url })
      // console.log('_onTestUploadPress uploadResponse', uploadResponse)
    } catch (error) {
      // console.log('_onTestUploadPress error', error)
    }
  }

  _renderXDocumentDropzoneExample = () => {
    if (MODE !== 'dev') {
      return null
    }

    // @ts-ignore
    const { selectedFile: sf, uploadedUrl } = this.state

    if (uploadedUrl) {
      return (
        <XCard>
          <VStack w='full' p='2' space='2'>
            <XText fontSize='md' bold>
              ไฟล์ที่อัพโหลดแล้ว
            </XText>
            <XText variant='inactive'>โผล่เฉพาะ dev mode</XText>

            <TouchableOpacity onPress={() => Linking.openURL(uploadedUrl)}>
              <XText variant='active' style={{ textDecorationLine: 'underline' }}>
                {uploadedUrl}
              </XText>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                // @ts-ignore
                this.setState({ uploadedUrl: null, selectedFile: null })
              }}
            >
              <XText variant='primary'>อัพโหลดใหม่</XText>
            </TouchableOpacity>
          </VStack>
        </XCard>
      )
    }

    return (
      <XCard>
        <VStack w='full' p='2' space='1.5'>
          <XText fontSize='md' bold>
            ทดสอบ XDocumentDropzone ที่นี่
          </XText>
          <XText variant='inactive'>โผล่เฉพาะ dev mode</XText>

          <XDocumentDropzone
            onFileSelect={async (file) => {
              console.log('XDocumentDropzone onDrop file', file)
              // @ts-ignore
              this.setState({ selectedFile: file })
            }}
            acceptFileTypes={['image', 'pdf']}
            renderContent={({ isDragActive, openDocumentPicker }) => (
              <TouchableOpacity onPress={openDocumentPicker}>
                <VStack
                  w='full'
                  minH='100px'
                  p='2'
                  alignItems='center'
                  justifyContent='center'
                  borderWidth='1'
                  borderRadius='lg'
                  borderColor='primary.500'
                  borderStyle='dashed'
                  bg={isDragActive ? 'primary.500' : 'primary.100'}
                >
                  {sf && <XText>ไฟล์ที่เลือก...</XText>}
                  {sf && (
                    <VStack
                      w='250px'
                      minH='80px'
                      p='1'
                      space='1.5'
                      borderWidth='1'
                      borderRadius='lg'
                      borderColor='muted.400'
                      bg='white'
                      // justifyContent='center'
                      // alignItems='center'
                    >
                      {sf.mime.startsWith('image') && (
                        <XImage
                          source={{ uri: `data:image/png;base64,${sf.data}` }}
                          alt='image'
                          w='50px'
                          h='50px'
                          borderRadius='md'
                          resizeMode='cover'
                        />
                      )}

                      {sf.mime.startsWith('application/pdf') && (
                        <XIcon name='file-pdf-box' family='MaterialCommunityIcons' size='lg' color='red.500' />
                      )}

                      <HStack w='full'>
                        <XText variant='inactive'>
                          ชื่อไฟล์:{' '}
                          <XText variant='active' bold>
                            {sf.name}
                          </XText>
                        </XText>
                      </HStack>
                      <HStack w='full'>
                        <XText variant='inactive'>
                          ชนิดไฟล์: <XText variant='active'>{sf.mime}</XText>
                        </XText>
                      </HStack>

                      <HStack style={{ position: 'absolute', top: -12, right: -12 }}>
                        <XIconButton
                          name='close-circle'
                          onPress={() => {
                            // @ts-ignore
                            this.setState({ selectedFile: null })
                          }}
                        />
                      </HStack>
                    </VStack>
                  )}

                  {!sf && <XText>วางไฟล์ที่นี่ หรือคลิกที่นี่</XText>}
                  {!sf && <XText variant='inactive'>ต้องเป็นไฟล์รูป หรือ pdf เท่านั้น</XText>}
                </VStack>
              </TouchableOpacity>
            )}
          />

          <XButton disabled={!sf} isDisabled={!sf} onPress={this._onTestUploadPress}>
            <XText>Test Upload</XText>
          </XButton>
        </VStack>
      </XCard>
    )
  }

  _renderPendingPackage = () => {
    const { pendingOrderData } = this.state

    if (_.isNil(pendingOrderData)) {
      return null
    }

    const renderNavToDetail = () => (
      <VStack w='full' alignItems='center' justifyContent='center'>
        <HStack>
          <XText
            textDecorationLine='underline'
            variant='inactive'
            mt='2'
            onPress={() => this._navToSelectedSubscriptionPackageView('pending')}
          >
            ดูรายละเอียด
          </XText>
          <XText
            ml='2'
            textDecorationLine='underline'
            variant='inactive'
            mt='2'
            color={COLORS.RED}
            onPress={() => this._cancelPendingOrder()}
          >
            ยกเลิกคำสั่งซื้อ
          </XText>
        </HStack>
        <TouchableOpacity
          // eslint-disable-next-line react/no-this-in-sfc
          onPress={() => this._navToSelectedSubscriptionPackageView('pending', true)}
          style={{
            backgroundColor: COLORS.APP_MAIN,
            borderRadius: 90,
            alignContent: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            height: 41,
            width: 90,
            marginTop: 10,
          }}
        >
          <XText color={COLORS.WHITE} bold textAlign='center'>
            ชำระเงิน
          </XText>
        </TouchableOpacity>
      </VStack>
    )
    return <XPendingSubcriptionPayment pendingOrderData={pendingOrderData} footerComponent={() => renderNavToDetail()} />
  }

  _renderLoadingCancelSubscription = () => {
    const { isLoadingCancelSubscription } = this.state
    if (!isLoadingCancelSubscription) {
      return null
    }
    return (
      <XOverlayLoading isVisibleLoadingOverlay={isLoadingCancelSubscription} loadingText={`กำลังยกเลิกคำสั่งซื้อ\nกรุณารอสักครู่...`} />
    )
  }

  render() {
    const { isInitialized } = this.state
    // util.logRender(this)
    const { profile, subscription } = this.props
    if (!isInitialized || !subscription || !subscription.get('user_id')) {
      return (
        <XSpinner
          style={{
            flex: 1,
            width: '100%',
            paddingVertical: 10,
            backgroundColor: APP_SECONDARY,
          }}
          color={APP_MAIN}
        />
      )
    }
    if (!subscription.has('type')) {
      return null
    }
    // subscription detail
    // const billingDate = subscription.get('billing_date') || moment()
    const startBillingDate = subscription.get('startBillingDate') || moment()
    const endBillingDate = subscription.get('endBillingDate') || moment()
    const orderCount = subscription.get('order_count_curr') || 0
    const orderQuota = subscription.get('order_count_quota') || 0
    const mainPackageOrderQuota = subscription.get('order_count_quota') || 0
    const ugGroups = subscription.get('ug_quota')
    const pgGroups = subscription.get('pg_quota')
    let colorOrderQuota = TEXT_ACTIVE
    const orderCountPerQuota = orderCount / orderQuota
    if (orderCountPerQuota >= orderDangerInPercentage) {
      colorOrderQuota = BRAND_Danger
    } else if (orderCountPerQuota >= orderWarningInPercentage) {
      colorOrderQuota = BRAND_Warning
    }
    const dEnd = moment(endBillingDate, SERVER_DATE_FORMAT)
    const txtEndBillingIn = dEnd.clone().fromNow()
    const txtStartBillingDate = moment(startBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    const txtEndBillingDate = moment(endBillingDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    // package detail
    const packages = subscription.get('packages')

    let txtMainPackageName = this.mainPackageItems[0].label
    let txtMainPackageBegin = null
    let txtMainPackageEnd = null
    let txtExpireMainPackageIn = null
    let colorExpireMainPackageIn = TEXT_ACTIVE

    const packageId = subscription.get('type') || 1
    const currentPackage = this.mainPackageItems.find((item) => item.value === packageId)

    if (currentPackage && currentPackage.label) {
      txtMainPackageName = currentPackage.label
    }
    const mBeginDate = subscription.has('m_s_date') ? subscription.get('m_s_date') : null
    const mEndDate = subscription.has('m_s_date') ? subscription.get('m_e_date') : null

    if (mBeginDate) {
      txtMainPackageBegin = moment(mBeginDate, SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
    }
    if (mBeginDate) {
      const endDate = moment(mEndDate, SERVER_DATE_FORMAT)
      txtMainPackageEnd = endDate.clone().format(LOCAL_DATE_FORMAT)
      txtExpireMainPackageIn = endDate.clone().fromNow()

      // Check dayToExpire for warning color
      const dayToExpire = endDate.clone().diff(moment(), 'days')
      if (dayToExpire > expireDangerInDay && dayToExpire < expireWarningInDay) {
        colorExpireMainPackageIn = BRAND_Warning
      } else if (dayToExpire <= expireDangerInDay) {
        colorExpireMainPackageIn = BRAND_Danger
      }
    }

    // const headerTitle = this._hideObject() ? 'รายละเอียดการใช้งาน' : p.op.t('NavTitle.package')
    // const headerTitle = 'แพ็กเกจของฉัน'
    const headerTitle = 'แพ็กเกจของฉัน'

    return (
      <XContainer>
        <XStatusBar backgroundColor='#fff' />
        <XCustomHeader title={headerTitle} headerLeftProps={{ backIcon: true, onPressItem: () => util.navGoBack(this.props) }} />
        <XContent
          // p='1'
          style={{ backgroundColor: BG_LIGHT_GREY }}
          refreshControl={
            <RefreshControl
              refreshing={this.state.refreshing}
              onRefresh={() => {
                // this.isViewMounted = true
                this._onRefresh()
                // this.isViewMounted = false
              }}
            />
          }
        >
          {this._renderProfile()}
          {this._renderWarningNotOwner()}
          {this._renderWarningPerPackage()}
          {this._renderWarningOrderQuota()}
          {this._renderWarningOverQuota()}
          {this._renderPendingPackage()}
          {/* {this._renderNavToUpgradePakage()} */}
          {/* {this._renderExtendPackageButton()} */}
          {/* {this._renderPackage()} */}
          {this._renderMyPackage()}
          {/* {this._renderPackageDetails()} */}
          {/* {this._renderOldPackageDetail()} */}

          {/* {!p.op.isIOS() ? (
            <XCard mt='2'>
              <XCard.Body style={{ justifyContent: 'center', alignItems: 'center' }}>
                <XText bold>สนใจสอบถามหรือซื้อแพ็กเกจติดต่อ</XText>
              </XCard.Body>

              <XCard.Body style={{ paddingHorizontal: 17, justifyContent: 'center', alignItems: 'center' }} />

              <XCard.Body>
                <ContactButtons />
              </XCard.Body>
            </XCard>
          ) : null} */}

          {/* {this._renderXDocumentDropzoneExample()} */}
          {this._renderLoadingCancelSubscription()}
        </XContent>
      </XContainer>
    )
  }
}
